<script lang="ts">
  import * as Popover from "$lib/components/ui/popover/index.js";
  import { Button } from "$lib/components/ui/button/index.js";
  import { detailsStore } from "$lib/stores/details.svelte";
  import { Loader2, Hexagon } from "lucide-svelte";

  function formatDate(date: string) {
    return new Date(date).toLocaleDateString("hu-HU", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  }

  let open = $state(false);
</script>

<Popover.Root bind:open>
  <!-- Trigger: hexagon rating display -->
  <Popover.Trigger
    class="flex items-center gap-2 cursor-pointer py-2 hover:-translate-y-0.5 transition-all hover:shadow-[2px_2px_0px_0px] rounded-md hover:bg-primary/80 {open
      ? '-translate-y-0.5 shadow-[2px_2px_0px_0px] bg-primary'
      : ''}"
    disabled={detailsStore.ratingsLoading}
  >
    <div class="flex items-center">
      {#each Array(5) as _, index}
        <Hexagon
          class="h-5 w-5 {index < (detailsStore.currentPoiDetail?.rating ?? 0)
            ? 'fill-primary'
            : 'fill-background'}"
        />
      {/each}
    </div>
    <span class="text-sm text-foreground">
      ({detailsStore.currentPoiDetail?.ratingNumber} értékelés)
    </span>
  </Popover.Trigger>

  <!-- Content: reviews list -->
  <Popover.Content
    class="w-96 max-h-[400px] overflow-y-auto p-3 space-y-3 bg-primary/50 border-none"
  >
    {#if detailsStore.ratingsLoading && detailsStore.ratings.length === 0}
      <div class="flex justify-center py-6">
        <Loader2 class="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    {:else if detailsStore.ratings.length === 0}
      <p class="text-sm text-muted-foreground">Még nincsenek értékelések.</p>
    {:else}
      <div class="space-y-2">
        {#each detailsStore.ratings as rating}
          <div
            class="border border-black border-r-2 border-b-2 rounded-md p-3 space-y-2 bg-card"
          >
            <div class="flex justify-between">
              <!-- Rating stars -->
              <div class="flex items-center gap-1">
                {#each Array(5) as _, i}
                  <Hexagon
                    class="h-4 w-4 {i < rating.rating
                      ? 'fill-primary'
                      : 'fill-background'}"
                  />
                {/each}
              </div>

              <!-- Author + date aligned right -->
              <div
                class="flex justify-end items-center gap-2 text-sm text-muted-foreground"
              >
                <span class="font-semibold text-foreground"
                  >{rating.user.nickname}</span
                >
                <span>· {formatDate(rating.createdDate)}</span>
              </div>
            </div>

            <!-- Review as a quote -->
            {#if rating.review}
              <blockquote
                class="border-l-2 border-primary pl-3 italic text-sm font-medium text-foreground leading-snug"
              >
                “{rating.review}”
              </blockquote>
            {/if}
          </div>
        {/each}
      </div>

      <!-- Load more -->
      {#if detailsStore.ratingsHasMore}
        <div class="flex justify-center pt-2">
          <Button
            variant="outline"
            size="sm"
            class="cursor-pointer bg-secondary/60 hover:bg-primary"
            disabled={detailsStore.ratingsLoading}
            onclick={() => detailsStore.loadMoreRatings()}
          >
            {#if detailsStore.ratingsLoading}
              <Loader2 class="h-4 w-4 animate-spin mr-2" />
              Betöltés...
            {:else}
              További értékelések
            {/if}
          </Button>
        </div>
      {/if}
    {/if}
  </Popover.Content>
</Popover.Root>
